module.exports = __webpack_public_path__ + "img/status_define_generic_controls.b95c29b1.gif";